<button type="button" (click)="_open()">
    <i class="material-icons">facebook</i>
    <span>{{'Login com Facebook' | translate}}</span>
</button>      
<loader message="Logando. Aguarde!" *ngIf="loader"></loader>  